import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { DestinatarioDTO } from "@app/shared/dto/gescor/destinatarioDTO";
import { DestinatarioVO } from "@app/shared/vo/gescor/destinatarioVO";
import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";
import { RecapitoVO } from "@app/shared/vo/gescor/recapitoVO";
import { MapperRecapito } from "./mapper-recapito";

@Injectable({
  providedIn: "root"
})
export class MapperDestinatario
  implements MapperInterface<DestinatarioDTO, DestinatarioVO> {
  constructor(private mapperRecapito: MapperRecapito) { }

  convertVoToDto(destinatarioVO: DestinatarioVO): DestinatarioDTO {
    // console.log("[MapperDestinatario - convertVoToDto]", destinatarioVO);
    const destinatarioDTO = new DestinatarioDTO();
    destinatarioDTO.tipoDestinatario = destinatarioVO.tipoDestinatario;
    destinatarioDTO.denominazioneRecapito =
      destinatarioVO.recapitoVO.denominazioneRecapito;
    destinatarioDTO.denominazioneSoggetto =
      destinatarioVO.recapitoVO.denominazioneSoggetto;
    destinatarioDTO.idRecapito = destinatarioVO.recapitoVO.idRecapito;
    destinatarioDTO.idSoggetto = destinatarioVO.recapitoVO.idSoggetto;
    if (
      destinatarioVO.recapitoVO.tipo != undefined &&
      destinatarioVO.recapitoVO.tipo.valueOf() ==
      TipoRecapitoAnagrafeEnum.PORTALE_WEB
    ) {
      destinatarioDTO.invio = false;
    }
    if (
      destinatarioVO.recapitoVO.tipoRecapito != undefined &&
      destinatarioVO.recapitoVO.tipoRecapito.valueOf() ==
      TipoRecapitoAnagrafeEnum.PORTALE_WEB
    ) {
      destinatarioDTO.invio = false;
    }
    return destinatarioDTO || new DestinatarioDTO();
  }
  convertDtoToVo(destinatarioDTO: DestinatarioDTO): DestinatarioVO {
    // console.log("[MapperDestinatario - convertDtoToVo]", destinatarioDTO);
    const destinatarioVO = new DestinatarioVO();
    const recapitoVO = new RecapitoVO();
    destinatarioVO.tipoDestinatario = destinatarioDTO.tipoDestinatario;
    recapitoVO.denominazioneRecapito = destinatarioDTO.denominazioneRecapito;
    recapitoVO.denominazioneSoggetto = destinatarioDTO.denominazioneSoggetto;
    recapitoVO.idRecapito = destinatarioDTO.idRecapito;
    recapitoVO.idSoggetto = destinatarioDTO.idSoggetto;
    destinatarioVO.recapitoVO = recapitoVO;

    // console.log("MapperDestinatario", destinatarioVO);
    return destinatarioVO || new DestinatarioVO();
  }
  convertListVoToDto(destinatarioVOList: DestinatarioVO[]): DestinatarioDTO[] {
    const destinatarioDTOList = new Array<DestinatarioDTO>();
    destinatarioVOList.forEach((destinatarioVO) => {
      destinatarioDTOList.push(this.convertVoToDto(destinatarioVO));
    });
    return destinatarioDTOList || new Array<DestinatarioDTO>();
  }
  convertListDtoToVo(destinatarioDTOList: DestinatarioDTO[]): DestinatarioVO[] {
    const destinatarioVOList = new Array<DestinatarioVO>();
    if (destinatarioDTOList != null) {
      destinatarioDTOList.forEach((destinatarioDTO) => {
        destinatarioVOList.push(this.convertDtoToVo(destinatarioDTO));
      });
    }
    return destinatarioVOList;
  }
}
